import { Link } from 'react-router-dom'
import { Helmet } from 'react-helmet-async'
import { Button } from '@/components/ui/button'
import { getPageTitle } from '@/lib/branding'

export function NotFoundPage() {
  return (
    <>
      <Helmet>
        <title>{getPageTitle('Page Not Found')}</title>
      </Helmet>
      <div className="container mx-auto px-4 py-20 text-center">
        <h1 className="text-4xl md:text-5xl font-bold tracking-tight">Page not found</h1>
        <p className="mt-4 text-muted-foreground">
          The page you are looking for does not exist or has moved.
        </p>
        <Button asChild className="mt-8">
          <Link to="/">Return home</Link>
        </Button>
      </div>
    </>
  )
}
